/**
 * Central brand assets & product data.
 * Product PNGs will be uploaded later — placeholder = null triggers an elegant mock.
 */

export const ASSETS = {
  logoWhite: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/pkgaynak_logo%20white.webp',
  logoDark:  'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/pkgaynak_logo%20white.webp',
  otesaly:   'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/xl42ua9s_otesaly%20logo.png',
  reanzen:   'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/f2jjuwl1_378544748_122127639026009925_8540927718161826467_n.png',
};

export const CLINIC_LOGOS = [
  { id: 'dhuha',  name: 'Dr. Dhuha Redha',        src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/ksnbv287_logo%20dhuha.png' },
  { id: 'ahmed',  name: 'د. أحمد حسن للتجميل والليزر', src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/hmtlobxi_%D9%84%D9%88%D9%83%D9%88%20%D8%A7%D8%AD%D9%85%D8%AF%20%D8%AD%D8%B3%D9%8A%D9%86%20%D8%B4%D8%B4.png' },
  { id: 'queen',  name: 'Queen Baghdad',          src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/l6kjqe1m_%D9%83%D9%88%D9%8A%D9%86%20%D8%A8%D8%BA%D8%AF%D8%A7%D8%AF.png' },
  { id: 'gloria', name: 'Gloria MAC',             src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/iq103oiv_logo.webp' },
  { id: 'allure', name: 'Allure For Beauty',      src: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/lb264xxx_%D8%A7%D9%84%D9%88%D8%B1.png' },
];

// Real Before/After case images uploaded by the client.
export const CASES = [
  {
    id: 'lips-01',
    before: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/61oj4svj_Usta%20pi%C4%99knej%20Pauli%20%F0%9F%98%8D%20Nasze%20drugie%20spotkanie%21%20Przewi%C5%84%20palcem%2C%20%C5%BCeby%20zobaczy%C4%87%20jak%20usta%20wygl%C4%85daj%C4%85%20d.jpg',
    after:  'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/92fsalki_Usta%20pi%C4%99knej%20Pauli%20%F0%9F%98%8D%20Nasze%20drugie%20spotkanie%21%20Przewi%C5%84%20palcem%2C%20%C5%BCeby%20zobaczy%C4%87%20jak%20usta%20wygl%C4%85daj%C4%85%20d%20%283%29.jpg',
  },
  {
    id: 'lips-02',
    before: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/4vcxyuft_%D8%B1%D8%A8%D9%84%D9%86%D8%AD%D9%86%20%D8%B4%D9%81%D9%87%20%D8%A8%D8%B9%D8%AF4_.jpg',
    after:  'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/96swpa1h_%D8%B1%D8%A8%D9%84%D9%86%D8%AD%D9%86%20%D8%B4%D9%81%D9%87%20%D9%824_.jpg',
  },
  {
    id: 'lips-03',
    before: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/xokeut2h_%D8%B1%D8%A8%D9%84%D9%86%D8%AD%D9%86%20%D8%B4%D9%81%D9%87%20%D8%A8%D8%B9%D8%AF3_.jpg',
    after:  'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/f39ec3e2_%D8%B1%D8%A8%D9%84%D9%86%D8%AD%D9%86%20%D8%B4%D9%81%D9%87%20%D9%823_.jpg',
  },
];

// Products grouped by brand. Currently ALL products belong to Reanzen per client's request.
// Otesaly collection is coming soon (empty for now).
export const BRANDS = {
  otesaly: {
    id: 'otesaly',
    logo: ASSETS.otesaly,
    accent: '#005CFF',
    accentSoft: 'rgba(0,92,255,0.18)',
    products: [
      {
        id: 'otesaly-1',
        number: '01',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/6dero6jx_%D8%A7%D9%88%D8%AA%D8%B3%D8%A7%D9%84%D9%8A%20%D8%A8%D8%AF%D9%8A.webp',
        variant: 'box',
        nameAr: 'Otesaly Derm Plus',
        nameEn: 'Otesaly Derm Plus',
        descAr: 'فلر أوتسالي ديرم بلس للجسم',
        descEn: 'Otesaly Derm Plus body filler',
      },
      {
        id: 'otesaly-2',
        number: '02',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/6nv4pe4m_otesaly%20lips.webp',
        variant: 'box',
        nameAr: 'Otesaly Filler Deep',
        nameEn: 'Otesaly Filler Deep',
        descAr: 'فلر أوتسالي ديب للشفاه',
        descEn: 'Otesaly Deep filler for lips',
      },
      {
        id: 'otesaly-3',
        number: '03',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/rg8i69nc_DSC06262.webp',
        variant: 'box',
        nameAr: 'Mesotherapy Solution',
        nameEn: 'Mesotherapy Solution',
        descAr: 'ميزو أوتسالي — محلول ميزوثيرابي غني بالفيتامينات والأحماض الأمينية والمعادن، يعمل على تجديد خلايا البشرة من العمق ويمنحها نضارة استثنائية وإشراقة صحية طبيعية دون تدخل جراحي.',
        descEn: 'Otesaly Meso — an advanced mesotherapy solution rich in vitamins, amino acids and minerals that regenerates the skin from within, delivering exceptional freshness and a natural, healthy glow.',
      },
      {
        id: 'otesaly-4',
        number: '04',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/c02ixsxl_otesaly%20png%203d.webp',
        variant: 'box',
        nameAr: 'Botox Otesaly',
        nameEn: 'Botox Otesaly',
        descAr: 'بوتكس أوتسالي 100 يونت',
        descEn: 'Otesaly Botox 100 units',
      },
    ],
  },
  reanzen: {
    id: 'reanzen',
    logo: ASSETS.reanzen,
    accent: '#40D3BE',
    accentSoft: 'rgba(64,211,190,0.22)',
    products: [
      {
        id: 'reanzen-fine',
        number: '01',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/17zc374x_%D9%81%D8%A7%D9%8A%D9%86.png',
        variant: 'box',
        nameAr: 'Replengen Fine',
        nameEn: 'Replengen Fine',
        descAr: 'فلر ربلنجن فاين لتحت العين',
        descEn: 'Replengen Fine — Under-eye Filler',
      },
      {
        id: 'reanzen-kiss',
        number: '02',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/z14v8o0w_Replengen%20kiss.png',
        variant: 'box',
        nameAr: 'Replengen Kiss Filler',
        nameEn: 'Replengen Kiss Filler',
        descAr: 'فلر ربلنجن للشفاه',
        descEn: 'Replengen Kiss — Lip Filler',
      },
      {
        id: 'reanzen-deep',
        number: '03',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/pcnvgkns_44.png',
        variant: 'box',
        nameAr: 'Replengen Deep',
        nameEn: 'Replengen Deep',
        descAr: 'فلر ربلنجن ديب للشفاه',
        descEn: 'Replengen Deep — Lip Filler',
      },
      {
        id: 'reanzen-volume',
        number: '04',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/ayhtjz49_%D9%81%D9%88%D9%84%D9%88%D9%8A%D9%85.png',
        variant: 'box',
        nameAr: 'Replengen Volume',
        nameEn: 'Replengen Volume',
        descAr: 'فلر ربلنجن فوليوم للوجه',
        descEn: 'Replengen Volume — Facial Filler',
      },
      {
        id: 'reanzen-implant-s',
        number: '05',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/4m85rjhe_%D8%A7%D9%85%D8%A8%D9%84%D8%A7%D9%86%D8%AA%20%D8%A7%D8%B3.png',
        variant: 'box',
        nameAr: 'Replengen Implant S',
        nameEn: 'Replengen Implant S',
        descAr: 'تحديد ملامح الوجه: تعبئة ورسم منطقة الذقن والفك (تكساس) وتحديد الوجنتين. علاج التجاعيد العميقة: ملء الطيات والخطوط العميقة جداً في الوجه. زيادة حجم الجسم: يُستخدم أحياناً لإعادة تشكيل وزيادة حجم بعض مناطق الجسم. الميزات التقنية — تقنية الحقن الجزيئي: تضمن توزيع الجل بشكل متجانس، مما يمنح مظهراً متناسقاً ويقلل من احتمالية التكتل. ثبات عالي: بفضل مرونته العالية، يقاوم الفيلر التحلل السريع داخل الجسم. المدة: تدوم نتائج الحقن لفترة طويلة تصل إلى 18 شهراً. مكونات العبوة الشائعة: سرنجة واحدة تحتوي على 1.1 مل من الفيلر.',
        descEn: 'Facial Contouring: sculpts and defines the chin, jawline and cheekbones. Deep Wrinkle Correction: fills very deep folds and lines. Body Volumization: occasionally used to reshape and add volume to specific body areas. Technical Features — Molecular Injection Technology: ensures homogeneous gel distribution for a natural look and reduced risk of lumps. High Cohesivity: resists rapid degradation inside the body. Longevity: results last up to 18 months. Standard Pack: one syringe containing 1.1 ml of filler.',
      },
      {
        id: 'reanzen-20plus',
        number: '06',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/g87sqyzf_20%20%D8%A8%D9%84%D8%B3.png',
        variant: 'box',
        nameAr: 'Replengen 20 PLUS',
        nameEn: 'Replengen 20 PLUS',
        descAr: 'فلر «ربلنجن 20 بلس» (Replengen 20 Plus) هو نوع من أنواع حقن حمض الهيالورونيك الكورية المصممة لعلاج الخطوط الدقيقة والتجاعيد السطحية وتحسين مرونة الجلد. يتميز بتقنيات حديثة لترطيب وتصحيح البشرة، وتدوم نتائجه لفترة طويلة تتراوح بين 12 إلى 18 شهراً.',
        descEn: 'Replengen 20 Plus is a Korean Hyaluronic Acid filler formulated to treat fine lines and superficial wrinkles while improving skin elasticity. Featuring advanced hydration and correction technologies, its results last between 12 and 18 months.',
      },
      {
        id: 'reanzen-40plus',
        number: '07',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/61rjdtu6_40%20%D8%A8%D9%84%D8%B3.png',
        variant: 'box',
        nameAr: 'Replengen 40 PLUS',
        nameEn: 'Replengen 40 PLUS',
        descAr: 'فلر ربلنجن 40 بلس (Replengen 40 Plus) هو حقن مخصص للجسم يحتوي على حمض الهيالورونيك عالي التشابك مع الليدوكائين لتخفيف الألم. يُستخدم لزيادة حجم مناطق الجسم مثل الأرداف أو الوركين أو الثديين، وتحسين مظهر الخطوط العميقة. تدوم نتائجه غالباً بين 12 إلى 18 شهراً.',
        descEn: 'Replengen 40 Plus is a body-dedicated filler containing highly cross-linked Hyaluronic Acid with Lidocaine for painless injection. Used to volumize body areas such as the buttocks, hips or breasts and improve the appearance of deep lines. Results typically last between 12 and 18 months.',
      },
      {
        id: 'reanzen-revs-pn',
        number: '08',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/7uiydlq7_%D8%B1%D9%8A%D9%81%D8%B2.png',
        variant: 'box',
        nameAr: 'REVS PN Filler',
        nameEn: 'REVS PN Filler',
        descAr: 'معزز حيوي لتنشيط الجلد من كوريا الجنوبية يجمع بين البولينيوكليوتيدات (PN) المستخرجة من الحمض النووي لسمك السلمون مع حمض الهيالورونيك (HA). على عكس الحشوات الجلدية الهيكلية الثقيلة، فإنه يصلح الأنسجة على المستوى الخلوي، ويحسن المرونة، ويشد المسام، ويرطب الوجه بعمق.',
        descEn: 'A South Korean skin-revitalizing biostimulator combining Polynucleotides (PN) derived from salmon DNA with Hyaluronic Acid (HA). Unlike heavy structural dermal fillers, it repairs tissue at the cellular level, enhances elasticity, tightens pores, and deeply hydrates the face.',
      },
      {
        id: 'reanzen-revs-pro',
        number: '09',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/yqbwnvcl_%ED%94%84%EB%A1%9C32.png',
        variant: 'box',
        nameAr: 'REVS PRO 32',
        nameEn: 'REVS PRO 32',
        descAr: 'محفز حيوي ومقوي للبشرة — الترطيب العميق: يمنح البشرة ترطيباً مكثفاً من الداخل. شد البشرة: يعالج الترهلات ويعيد مرونة الجلد ونضارته. تجديد الأنسجة: يحفز خلايا الجلد الحية ويحسن ملمس ورونق الأنسجة المتضررة. طريقة الحقن: غالباً ما يتم إعطاؤه عبر تقنية النقاط الخمس (5-point) أو الحقن الدقيق.',
        descEn: 'A biostimulator and skin booster — Deep Hydration: delivers intensive hydration from within. Skin Tightening: treats sagging and restores elasticity and radiance. Tissue Regeneration: activates living skin cells and improves texture of damaged tissue. Application: commonly administered via the 5-point technique or micro-injections.',
      },
      {
        id: 'reanzen-rmt',
        number: '10',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/fhuzuq83_RMT140HPn.png',
        variant: 'box',
        nameAr: 'RMT 140HPn',
        nameEn: 'RMT 140HPn',
        descAr: 'التركيب الأساسي: يجمع بين البولينيوكليوتيدات المشتقة من سمك السلمون (PN) مع حمض الهيالورونيك (HA) عالي الوزن الجزيئي بتركيز 1.4 مليون دالتون. المركب النشط: يحتوي على ما يقرب من 50 مكوّناً نشطاً إضافياً بما في ذلك الفيتامينات والأحماض الأمينية والمعادن والإنزيمات المساعدة والجلوتاثيون. التعبئة والتغليف: صندوق يحتوي على 10 قوارير (3 مل لكل منها). تجديد البشرة: تركيبة لتحفيز تجديد الخلايا، وتعزيز الترطيب، وتحسين مرونة الجلد بشكل عام.',
        descEn: 'Core Composition: combines salmon-derived Polynucleotides (PN) with high-molecular-weight Hyaluronic Acid (HA) at 1.4 million Daltons. Active Complex: contains nearly 50 additional active ingredients including vitamins, amino acids, minerals, coenzymes and glutathione. Packaging: a box of 10 vials (3 ml each). Skin Renewal: a formulation designed to stimulate cellular regeneration, boost hydration and improve overall skin elasticity.',
      },
    ],
  },
  brand3: {
    id: 'brand3',
    logo: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/bjvdjah7_jd_bio.png',
    accent: '#C60C30',
    accentSoft: 'rgba(198,12,48,0.14)',
    products: [
      {
        id: 'redtox-1',
        number: '01',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/ecq2eawv_ChatGPT%20Image%20Aug%2017%2C%202026%2C%2011_20_34%20PM.png',
        variant: 'box',
        nameAr: 'Red Tox 100 Units',
        nameEn: 'Red Tox 100 Units',
        descAr: 'بوتكس ريد توكس فعّال في التخلص من تجاعيد منطقة الوجه.\n✔️ نقاوة وجودة تصنيع عالية.\n✔️ توزيع متوازن أثناء الحقن.\n✔️ نتائج طبيعية تدوم وفق البروتوكولات العلاجية المعتمدة.',
        descEn: 'Red Tox Botox effectively erases facial wrinkles.\n✔️ High purity and manufacturing quality.\n✔️ Balanced diffusion during injection.\n✔️ Natural, long-lasting results following approved treatment protocols.',
      },
    ],
  },
  brand4: {
    id: 'brand4',
    logo: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/zn47m8np_Untitled-1.png',
    accent: '#EC5B8E',
    accentSoft: 'rgba(236,91,142,0.16)',
    products: [
      {
        id: 'bm-hyrunidase-1',
        number: '01',
        image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_premium-medica/artifacts/xpfezxzo_%EB%B9%84%EC%97%A0%ED%9E%88%EB%A3%A8%EB%8B%88%EB%8B%A4%EC%A0%9C%EC%A3%BC-%EC%9E%91%EC%9D%80%EC%82%AC%EC%9D%B4%EC%A6%88-4.png',
        variant: 'box',
        nameAr: 'BM Hyrunidase',
        nameEn: 'BM Hyrunidase',
        descAr: 'مذيب فلر.\nالتركيز: 1500 وحدة دولية من الهيالورونيداز في 1 مل.\nالفعالية:\n✔️ يزيد من نفاذية الحقن تحت الجلد أو داخل العضل والحقن الموضعي المخدّر.\n✔️ يعزّز إعادة امتصاص السوائل الزائدة والدم في الأنسجة.\nالعبوة: صندوق يحتوي على 10 قوارير.',
        descEn: 'Filler dissolver.\nConcentration: 1500 IU of Hyaluronidase in 1 mL.\nEfficacy:\n✔️ Increases penetration for subcutaneous and intramuscular injections and local anesthetics.\n✔️ Promotes reabsorption of excess body fluids and blood in tissues.\nPackaging: 10 vials per case.',
      },
    ],
  },
};
